import { useEffect, useState } from "react";
import "./Dashboard.css";
import TopSection from "./TopSection";
import RevenueOverviewContainer from "./RevenueOverviewContainer";
import CashFlowChart from "./CashFlowChart";
import ExpenseDistributionDashboard from "./ExpenseDistributionDashboard";
import PerformanceOverview from "./PerformanceOverview";
import VacancyRate from "./VacancyRate";
import { UserLoginData } from "../components/common/charts/Enums";
import { useAnalyticsHook } from "../hooks/useAnalyticsHook";
import { AnalyticsService } from "@propertelligent/client-api";
import SimpleSpinner from "../components/loader";

const Dashboard = ({ showDashbordName = true }) => {
  const organization_id = Number(sessionStorage.getItem(UserLoginData.organization_id));
  const [fin_monthValue, setFin_MonthValue] = useState(-12);
  const [loadingStates, setLoadingStates] = useState({
    topSectionLoading: true,
    revenueLoading: true,
    cashFlowLoading: true,
    expanseDistrubutionLoading: true,
    vacancyRateLoading: true,
    performanceOverviewLoading: true,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isLoaded = Object.values(loadingStates).every(
      (value) => value === false
    );
    setLoading(!isLoaded);
  }, [loadingStates]);

  const customMonthField = "monthYear";

  const { expensebycategoryArr, loading: dataLoading } = useAnalyticsHook({
    httpExpensebycategoryFn: AnalyticsService.getApiAnalyticsOrganizationExpensebycategory,
    customMonthField,
    parentEntityId: organization_id,
    fullyQualifiedFilters: {
      fin: `Created>DateTime.UtcNow.AddMonths(${fin_monthValue})`,
    },
  });

  useEffect(() => {
    setLoadingStates((loadingStates) => ({
      ...loadingStates,
      expanseDistrubutionLoading: false,
    }));
  }, [dataLoading]);

  return (
    <>
      {loading && (
        <div className="loading-container">
          <SimpleSpinner
            myClassName={"Icon50"}
          />
        </div>
      )}
      <div className="dashboardMainContainer" style={{ display: loading == true && "none" }}>

        {showDashbordName && (
          <div className="dashboardTopBar">
            <p className="top_header">Dashboard</p>
          </div>
        )}
        <TopSection
          loadingStates={loadingStates}
          setLoadingStates={setLoadingStates}
        />
        <div className=" dashboardBottomContainer">
          <div className="leftSideDashboardComponents">
            <RevenueOverviewContainer
              loadingStates={loadingStates}
              setLoadingStates={setLoadingStates}
            />
            <CashFlowChart
              loadingStates={loadingStates}
              setLoadingStates={setLoadingStates}
            />
            <ExpenseDistributionDashboard
              data={expensebycategoryArr}
              fin_monthValue={fin_monthValue}
              setFin_MonthValue={setFin_MonthValue}
            />
            <VacancyRate
              loadingStates={loadingStates}
              setLoadingStates={setLoadingStates}
            />
          </div>
          <div className="rightSideDashboardComponents">
            <PerformanceOverview
              loadingStates={loadingStates}
              setLoadingStates={setLoadingStates}
            />
          </div>
        </div>

      </div>
    </>
  );
};

export default Dashboard;
